import { render, staticRenderFns } from "./RegistAccountDetail.vue?vue&type=template&id=dca8c93a&scoped=true"
import script from "./RegistAccountDetail.vue?vue&type=script&lang=js"
export * from "./RegistAccountDetail.vue?vue&type=script&lang=js"
import style0 from "./RegistAccountDetail.vue?vue&type=style&index=0&id=dca8c93a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca8c93a",
  null
  
)

export default component.exports